<template>
    <div style="height:100%;">
        <!-- 面包屑导航 -->
        <Breadcrumb :levelList="levelList"/>
        <!-- 条件 -->
        <div class="aibfb aimt20 pull-left">
            <el-button class="pull-right" type="primary" size="small" @click="labelPage">标签管理</el-button>
            <div class="entity_sysSearchOne aimr10 pull-right">
                <el-input placeholder="添加关键字" class="selectInput pull-right" v-model="entity_addsearch" size="small" clearable>
                    <svg slot="suffix" class="icon" aria-hidden="true" @click="search()">
                        <use xlink:href="#iconsearchicon" />
                    </svg>
                </el-input>
            </div>
            <el-select class="pull-right aimr10 entity_w130" size="small" v-model="entity_sysSelect" placeholder="所有状态" clearable>
                <el-option label="已启用" :value="1">已启用</el-option>
                <el-option label="已禁用" :value="0">已禁用</el-option>
            </el-select>
        </div>
        <!-- 列表 -->
        <div class="aibfb pull-left aimt10 entity_sysListBox">
            <div class="entity_sysList">
                <div class="entity_sysListAdd text-center" @click="clickAddButton()">
                    <span class="iconfont icon-xinzeng"></span>
                    <div class="entity_sysListAddTxt">新增模型</div>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="entity_sysList entity_sysDisable" v-for="(item, index) in listData" :key="index">
                <div class="entity_sysListTop">
                    <div class="entity_sysListImg">
                        <img src="@/assets/images/entity/entity_img1.png" v-if="!item.data.imageUrl">
                        <img :src="getImgUrl(item.data.imageUrl)" v-if="item.data.imageUrl">
                    </div>
                    <div class="entity_sysListTxt">
                        <div class="entity_sysListTxtTitle">{{item.text}}</div>
                        <div class="entity_sysListTagBox">
                            <span>标签：</span>
                            <div class="entity_sysColor1 entity_sysListTag" :style="{ background: tag.colorSelection }" v-show="indexTag<=5" v-for="(tag, indexTag) in item.data.tagList" :key="indexTag">{{tag.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="entity_sysListBottom">
                    <ul>
                        <li  class="entity_sysDisableCp" v-if="item.data.state === 0">
                            <el-tooltip content="测试" placement="bottom" effect="light">
                                <span class="iconfont icon-bug"></span>
                            </el-tooltip>
                        </li>
                        <li  class="entity_sysDisableLi entity_sysDisableCp" v-if="item.data.state === 1" @click="textDialogOpen(item)">
                            <el-tooltip content="测试" placement="bottom" effect="light">
                                <span class="iconfont icon-bug"></span>
                            </el-tooltip>
                        </li>
                        <li class="entity_sysDisableCp" v-if="item.data.state === 0" @click="updateState(item)">
                            <el-tooltip content="禁用" placement="bottom" effect="light">
                                <span class="iconfont icon-suoguan"></span>
                            </el-tooltip>
                        </li>
                        <li class="entity_sysDisableLi entity_sysDisableCp" v-if="item.data.state === 1" @click="updateState(item)">
                            <el-tooltip content="启用" placement="bottom" effect="light">
                                <span class="iconfont icon-suokai"></span>
                            </el-tooltip>
                        </li>
                        <li class="entity_sysDisableLi entity_sysDisableCp" @click="corpusPage(item)">
                            <el-tooltip content="语料" placement="bottom" effect="light">
                                <span class="iconfont icon-wenzhang"></span>
                            </el-tooltip>
                        </li>
                        <li class="entity_sysDisableLi entity_sysDisableCp" @click="clickDeleteButton(item.id)">
                            <el-tooltip content="删除" placement="bottom" effect="light">
                                <span class="iconfont icon-table-delete"></span>
                            </el-tooltip>
                        </li>
                        <li class="entity_sysDisableLi entity_sysDisableCp" @click="clickEditButton(item)">
                            <el-tooltip content="编辑" placement="bottom" effect="light">
                                <span class="iconfont icon-table-bianji"></span>
                            </el-tooltip>
                        </li>
                    </ul>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <el-drawer class="entity_drawerBox" size="450px" title="" :visible.sync="drawerEdit">
            <div class="aibfb pull-left entity_drawerBtnHeader">
                <el-button class="pull-left" type="primary" size="small" @click="fromDataVersion('update')" v-if="editId !== ''">保 存</el-button>
                <el-button class="pull-left" type="primary" size="small" @click="fromDataVersion('add')"  v-if="editId === ''">保 存</el-button>
                <el-switch class="pull-right" v-model="entity_drawerSwitch" active-text="已启用" inactive-text="未启用"></el-switch>
            </div>
            <div class="aibfb pull-left entity_drawerEditCon" v-if="drawerEdit">
                <el-form ref="entity_drawerEditConForm" :model="entity_drawerEditConForm" :rules="entity_drawerEditConFormRules" label-width="80px">
                    <el-form-item label="模型名称" prop="name">
                        <el-input v-model="entity_drawerEditConForm.name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="图标">
                        <div>
                            <div class="aibfb pull-left">
                                <el-upload class="entity_upload-demo"
                                           ref="uploadFile"
                                           :headers="headers"
                                           :action="editId ? updateAction : addAction"
                                           :multiple="false"
                                           :data="paramsData"
                                           name="file"
                                           accept="image/*"
                                           :auto-upload="false"
                                           :limit="1"
                                           :on-change="fileOnChange"
                                           :on-preview="handlePreview"
                                           :on-remove="handleRemove"
                                           :on-success="fileOnSuccess"
                                           :on-error="fileOnError"
                                           :file-list="fileList"
                                           list-type="picture">
                                    <el-button size="small" type="info" icon="el-icon-plus">上传图片</el-button>
                                    <div slot="tip" class="el-upload__tip">*建议尺寸50px*50px，jpg/png/bmp/gif格式</div>
                                </el-upload>
                            </div>
                        </div>
                    </el-form-item>
                    <!--<el-form-item label="模型ID">
                        <el-input v-model="entity_drawerEditConForm.id" size="small"></el-input>
                    </el-form-item>-->
                </el-form>
            </div>
        </el-drawer>
        <el-drawer class="entity_drawerBox" size="450px" title="" :visible.sync="drawerTest">
            <div class="aibfb pull-left entity_drawerBtnHeader">
                <el-button class="pull-left" type="primary" size="small" @click="testData()">提 交</el-button>
                <el-button class="pull-left" type="primary" size="small">重新标注</el-button>
            </div>
            <div class="aibfb pull-left entity_drawerTestCon">
                <div class="aibfb pull-left">
                    <el-input type="textarea" v-model="entity_drawerTestTextarea"></el-input>
                </div>
                <div class="aibfb pull-left aimt15">
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column prop="result" label="识别结果"></el-table-column>
                        <el-table-column prop="name" label="实体名称"></el-table-column>
                    </el-table>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import { getEntityList, updateEntity, deleteEntity, addEntity, testCorpus } from '../../../../../api/entity/entity'
export default {
  components: { Breadcrumb },
  data() {
    return {
      levelList: [{ path: '@/views/entity/custom/tag', title: '实体标注' }],
      entity_addsearch: '',
      entity_sysSelect: '',
      entity_drawerSwitch: true,
      entity_drawerTestTextarea: '',
      drawerEdit: false,
      drawerTest: false,
      fileList: [],
      entity_drawerEditConForm: {
        name: '',
        id: ''
      },
      entity_drawerEditConFormRules: {
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      tableData: [],
      // ================================================>>
      listData: [],
      editId: '',
      openTempData: {},
      indexId: '',
      addAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_ENTITY_SERVICE') + '/entity/trainEntity',
      updateAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_ENTITY_SERVICE') + '/entity/trainEntitys',
      headers: { Authorization: this.getToken(), 'X-TENANT-ID': this.getCTenantId() },
      paramsData: {
        id: '',
        name: '',
        state: 0
      },
      imageUrl: '',
      imageIsChange: ''
    }
  },
  methods: {
    labelPage: function () {
      this.$emit('toIndex', 'label', {})
    },
    corpusPage(item) {
      this.$emit('toIndex', 'corpus', { ...item })
    },
    handlePreview(file) {
      console.log(file)
    },
    // ===================================================>>
    getImgUrl(path) {
      return window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_ENTITY_SERVICE') + '/res/download/entity/idx/show?url=' + path
    },
    /** 移除列表 */
    handleRemove(file, fileList) {
      this.imageUrl = ''
      this.imageIsChange = false
    },
    /** 上传列表 */
    fileOnChange(file, fileList) {
      this.imageIsChange = true
    },
    addEntitydFile() {
      this.paramsData.id = null
      this.paramsData.name = this.entity_drawerEditConForm.name
      this.paramsData.state = this.entity_drawerSwitch ? 1 : 0
      this.$refs.uploadFile.submit()
    },
    updateEntitydFile() {
      this.paramsData.id = this.editId
      this.paramsData.name = this.entity_drawerEditConForm.name
      this.paramsData.state = this.entity_drawerSwitch ? 1 : 0
      this.$refs.uploadFile.submit()
    },
    fileOnSuccess(response, file, fileList) {
      if (response.code === 2000) {
        this.search()
        this.drawerEdit = false
      } else {
        window.entityMessage({ type: 'warning', text: response.msg })
        this.$refs.uploadFile.clearFiles()
      }
    },
    fileOnError() {
      this.$refs.uploadFile.clearFiles()
    },
    /** 获取表单头 */
    getToken() {
      return localStorage.getItem('Authorization')
    },
    /** 获取租户id */
    getCTenantId() {
      return localStorage.getItem('X-TENANT-ID')
    },
    search() {
      const that = this
      this.listData = []
      const params = {
        search: this.entity_addsearch
      }
      if (this.entity_sysSelect !== '') {
        params.state = this.entity_sysSelect
      }
      getEntityList(params).then(response => {
        if (response.data.code === 2000) {
          const data = response.data.data
          if (data && data.length > 0) {
            data.forEach(function (item) {
              const json = {
                id: item.id,
                text: item.name,
                status: item.state === 1,
                data: {
                  ...item
                }
              }
              that.listData.push(json)
            })
          }
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    clickEditButton (item) {
      const data = JSON.parse(JSON.stringify(item))
      this.entity_drawerSwitch = data.data.state === 1
      this.entity_drawerEditConForm.name = data.text
      this.editId = data.id
      this.imageUrl = data.data.imageUrl
      if (this.imageUrl) {
        this.fileList = [{ name: data.text, url: this.getImgUrl(data.data.imageUrl) }]
      } else {
        this.fileList = []
      }
      this.imageIsChange = false
      this.drawerEdit = true
    },
    clickAddButton () {
      this.entity_drawerSwitch = ''
      this.entity_drawerEditConForm.name = ''
      this.editId = ''
      this.imageUrl = ''
      this.fileList = []
      this.imageIsChange = false
      this.drawerEdit = true
    },
    fromDataVersion(type) {
      this.$refs.entity_drawerEditConForm.validate((valid) => {
        if (valid) {
          if (type === 'update') {
            if (this.imageIsChange) {
              this.updateEntitydFile()
            } else {
              this.updateEntityd()
            }
          }
          if (type === 'add') {
            if (this.imageIsChange) {
              this.addEntitydFile()
            } else {
              this.addEntityd()
            }
          }
        } else {
          return false
        }
      })
    },
    updateEntityd() {
      const params = {
        id: this.editId,
        name: this.entity_drawerEditConForm.name,
        state: this.entity_drawerSwitch ? 1 : 0,
        oldImageUrl: this.imageUrl
      }
      updateEntity(params).then(response => {
        if (response.data.code === 2000) {
          this.search()
          this.drawerEdit = false
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    addEntityd () {
      const params = {
        name: this.entity_drawerEditConForm.name,
        state: this.entity_drawerSwitch ? 1 : 0
      }
      addEntity(params).then(response => {
        if (response.data.code === 2000) {
          this.search()
          this.drawerEdit = false
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    clickDeleteButton (indexId) {
      if (indexId === '') {
        return
      }
      const that = this
      const id = indexId
      window.entityMessageBox({
        title: '提示',
        text: '此操作将永久删除, 是否继续?',
        f: function() {
          that.deleteEntityd({ id })
        },
        c: function() {
        }
      })
    },
    deleteEntityd (params) {
      deleteEntity(params).then(response => {
        if (response.data.code === 2000) {
          this.search()
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    updateState(item) {
      const params = {
        id: item.id,
        name: item.text,
        state: item.data.state === 0 ? 1 : 0
      }
      updateEntity(params).then(response => {
        if (response.data.code === 2000) {
          item.data.state = item.data.state === 0 ? 1 : 0
          window.entityMessage({ type: 'success', text: '修改状态成功' })
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    textDialogOpen(item) {
      this.openTempData = item
      this.indexId = item.id
      this.tableData = []
      this.entity_drawerTestTextarea = ''
      this.drawerTest = true
    },
    testData() {
      if (this.entity_drawerTestTextarea === '') {
        window.entityMessage({ type: 'warning', text: '内容不能为空' })
      } else {
        this.tableData = []
        const that = this
        testCorpus({ id: this.indexId, question: this.entity_drawerTestTextarea }).then(response => {
          if (response.data.code === 2000) {
            const data = response.data.data
            if (data && data.length > 0) {
              data.forEach(function (item) {
                that.tableData.push({
                  result: item.content,
                  name: item.entity || ''
                })
              })
            }
          } else {
            window.entityMessage({ type: 'warning', text: response.data.msg })
          }
        }).catch(error => {
          window.entityMessage({ type: 'error', text: error.data.msg })
        })
      }
    }
  },
  mounted() {
    this.search()
  }
}
</script>
<style>
    .el-upload-list--picture .el-upload-list__item-name i {
        font-size: 12px;
    }
</style>
